import axios from 'axios';
import { SweetAlertBasic } from '../../sweetAlert';

export function setReportesFilters(filtersAdded) {
  return async (dispatch) => {
    dispatch(reportesSetFiltersInit());
    try {
      if (!filtersAdded) {
        dispatch(reportesSetFiltersSuccess({}));
      } else {
        let filters = { ...filtersAdded };
        if ('tiempo' in filtersAdded) {
          filters = { ...filters, ...filtersAdded.tiempo };
          delete filters.tiempo;
        }
        dispatch(reportesSetFiltersSuccess(filters));
      }
    } catch (error) {
      dispatch(reportesSetFiltersError());
    }
  };
}

export function getReportes() {
  return async (dispatch) => {
    dispatch(reportesInit());
    try {
      const response = await axios.get('/reportes');
      const data = await response.data;
      dispatch(reportesSuccess(data));
    } catch (error) {
      dispatch(reportesError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    }
  };
}

export function searchReports(data) {
  return async (dispatch) => {
    dispatch(searchReportInit());
    try {
      dispatch(searchReportSuccess(data));
    } catch (error) {
      dispatch(searchReportError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    }
  };
}

export function searchMultiReports(data) {
  return async (dispatch) => {
    dispatch(searchReportInit());
    try {
      dispatch(searchReportTabsSuccess(data));
    } catch (error) {
      dispatch(searchReportError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    }
  };
}

export function searchDelete(data) {
  return async (dispatch) => {
    dispatch(searchReportInit());
    try {
      dispatch(searchDeleteReport(data));
    } catch (error) {
      dispatch(searchReportError(error));
      SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
    }
  };
}

const initialState = {
  name: 'reportes',
  state: false,
  loading: true,
  reportes: [],
  search_report: [],
  searchMulti:[],
  arrayReport:[],
  reportesI:[],
  filtersSelected: {},
};

// Repository Init
const reportesInit = () => ({ type: 'REPORTES_INIT' });
const reportesError = (error) => ({ type: 'REPORTES_ERROR', payload: error });
const reportesSuccess = (data) => ({ type: 'REPORTES_SUCCESS', payload: data });

// Search Init
const searchReportInit = () => ({ type: 'SEARCH_REPORTES_INIT' });
const searchReportError = (error) => ({ type: 'SEARCH_REPORTES_ERROR', payload: error });
const searchReportSuccess = (data) => ({ type: 'SEARCH_REPORTES_SUCCESS', payload: data });
const searchReportTabsSuccess = (data) => ({ type: 'SEARCH_REPORTES_TABS_SUCCESS', payload: data });
const searchDeleteReport = (data) => ({ type: 'SEARCH_REPORTES_DElETE', payload: data });

// Filters Actions
const reportesSetFiltersInit = () => ({ type: 'SET_FILTERS_REPORTES_INIT' });
const reportesSetFiltersSuccess = (data) => ({ type: 'SET_FILTERS_REPORTES_SUCCESS', payload: data });
const reportesSetFiltersError = () => ({ type: 'SET_FILTERS_REPORTES_ERROR' });

export default function init(state = initialState, action) {
  switch (action.type) {
    case 'REPORTES_INIT':
    case 'SEARCH_REPORTES_INIT':
      return {
        ...state,
        loading: true,
      };

    case 'REPORTES_SUCCESS':
      return {
        ...state,
        loading: true,
        reportesI: action.payload,
        reportes: action.payload,
        search_report: action.payload,
      };
    case 'SEARCH_REPORTES_SUCCESS':
      return {
        ...state,
        loading: true,
        reportes: {data: state.reportes?.data.filter((item) => item.name.toLowerCase().includes(action.payload.toLowerCase()))},
        search_report: {data: state.reportes?.data.filter((item) => item.name.toLowerCase().includes(action.payload.toLowerCase()))},
      };
    case 'SEARCH_REPORTES_DElETE':
      let arrayReportD = []
      let arrayResultD = []
      const index = state.searchMulti.indexOf(action.payload);
      state.searchMulti.splice(index, 1);
      if (state.searchMulti.length > 0) {
        state.searchMulti?.forEach((search) => {
          arrayResultD.push(state.reportes?.data.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())))
        })
        arrayResultD.forEach((array) => {
          array.forEach((obj) => {
              arrayReportD.push(obj)
            }
          )
        })
        return {
          ...state,
          loading: true,
          reportes: {data: arrayReportD},
          search_report: {data: arrayReportD}
        };
      } else {
        return {
          ...state,
          loading: true,
          reportes: {data: state.reportesI?.data},
          search_report: {data: state.reportesI?.data}
        };
      }
    case 'SEARCH_REPORTES_TABS_SUCCESS':
      let arrayReport = []
      let arrayResult =[]
      state.searchMulti.push(action.payload)
      state.searchMulti?.forEach((search)=> {
        arrayResult.push(state.reportes?.data.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())))
      })
      arrayResult.forEach((array) => {
        array.forEach((obj) => {
            arrayReport.push(obj)
          }
        )
      })
      return {
        ...state,
        loading: true,
        reportes: { data: arrayReport},
        search_report: {  data: arrayReport}
      };
    case 'REPORTES_ERROR':
    case 'SEARCH_REPORTES_ERROR':
      return {
        state: false,
        loading: true,
        error: action.payload,
      };
    case 'SET_FILTERS_REPORTES_SUCCESS':
      return {
        ...state,
        filtersSelected: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
